import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu", "button"];

  connect() {
    this.close();
  }

  toggle() {
    this.menuTarget.classList.toggle("hidden");
    const isOpen = !this.menuTarget.classList.contains("hidden");
    this.buttonTarget.setAttribute("aria-expanded", String(isOpen));
  }

  close() {
    if (this.hasMenuTarget) {
      this.menuTarget.classList.add("hidden");
    }

    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("aria-expanded", "false");
    }
  }
}
